import { render, staticRenderFns } from "./SendEdit.vue?vue&type=template&id=75fc81d6&"
import script from "./SendEdit.vue?vue&type=script&lang=js&"
export * from "./SendEdit.vue?vue&type=script&lang=js&"
import style0 from "./SendEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SendEdit.vue"
export default component.exports